import translations from '../translations/**.js';

export const current = window.navigator.language;

const language = translations[current];
export default language && language.default ? language.default : language;
